import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export interface PageBackLinkProps {
  /** Destination-aware label, e.g. "Back to Garage" */
  label: string;
  to: string;
  className?: string;
}

/**
 * Consistent in-product return link for detail and form pages.
 * Always use a destination-specific label, never generic "Back".
 */
export const PageBackLink: React.FC<PageBackLinkProps> = ({ label, to, className = '' }) => (
  <Link
    to={to}
    className={`inline-flex items-center gap-1.5 text-sm text-gray-400 hover:text-white transition-colors duration-200 min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/50 rounded ${className}`.trim()}
  >
    <ArrowLeftIcon className="w-4 h-4 shrink-0" aria-hidden />
    {label}
  </Link>
);

export default PageBackLink;
